import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormInfo, ResponseInfo } from 'src/app/models/models';
import { GetEmpty } from 'src/app/classes/Empties';
import { BaseComponent } from 'src/app/pages/base/base.component';

/**
 * Modal para capturar una respuesta de formulario (response + answers) en línea.
 * Emite la ResponseInfo armada (response.id = 0) para que la página contenedora
 * la guarde dentro del payload de quote_info / order_info.
 *
 * Uso:
 *   <app-modal [(show)]="show_response_editor">
 *     <app-form-response-editor [form_id]="form_id" [user_id]="client_user_id"
 *       (responseChange)="onResponseEditorResponse($event)"></app-form-response-editor>
 *   </app-modal>
 */
@Component({
	selector: 'app-form-response-editor',
	templateUrl: './form-response-editor.component.html',
	styleUrls: ['./form-response-editor.component.css']
})
export class FormResponseEditorComponent extends BaseComponent implements OnChanges
{
	@Input() form_id:number | null | undefined = null;
	@Input() user_id:number | null | undefined = null; //Cliente al que se vincula la respuesta
	@Input() label:string = ''; //Titulo opcional del contexto (ej. nombre del artículo)
	@Output() responseChange = new EventEmitter<ResponseInfo>();

	response_info:ResponseInfo = GetEmpty.response_info(0);

	ngOnChanges(changes: SimpleChanges): void
	{
		if( changes['form_id'] && this.form_id )
		{
			this.loadForm();
		}

		if( changes['user_id'] )
		{
			this.response_info.response.user_id = this.user_id;
		}
	}

	loadForm()
	{
		this.is_loading = true;
		this.subs.sink = this.rest.form_info.get( this.form_id )
		.subscribe((form_info:FormInfo)=>
		{
			this.is_loading = false;
			let response_info = GetEmpty.response_info( form_info.form.id );
			response_info.form = form_info.form;
			response_info.response.user_id = this.user_id;
			response_info.answers = form_info.questions
			.filter((question)=>question.status == 'ACTIVE')
			.map((question)=>
			{
				let answer = GetEmpty.answer();
				answer.question_id = question.id;
				return {question, answer};
			});
			this.response_info = response_info;
			this.sortAnswers();
		},(error)=>
		{
			this.is_loading = false;
			this.showError(error);
		});
	}

	sortAnswers()
	{
		this.response_info.answers.sort((a,b)=> b.question.priority - a.question.priority);
	}

	getInputType(type:string):string
	{
		switch( type )
		{
			case 'number': return 'number';
			case 'date': return 'date';
			case 'tel': return 'tel';
			default: return 'text';
		}
	}

	accept()
	{
		let empty_required = this.response_info.answers.find((ai)=>
		{
			return ai.question.required == 1 && !(ai.answer.answer_text && String(ai.answer.answer_text).trim());
		});

		if( empty_required )
		{
			this.showError('La pregunta "'+empty_required.question.question+'" es obligatoria');
			return;
		}

		if( this.response_info.form.is_response_title_required == 1 && !this.response_info.response.title )
		{
			this.showError('Debes poner un título a la respuesta');
			return;
		}

		this.response_info.response.form_id = this.form_id as number;
		this.response_info.response.user_id = this.user_id;

		this.responseChange.emit( this.response_info );
	}
}
